import script from "./sw-item-parts-mailaddress.vue?vue&type=script&setup=true&lang=js"
export * from "./sw-item-parts-mailaddress.vue?vue&type=script&setup=true&lang=js"

import "./sw-item-parts-mailaddress.vue?vue&type=style&index=0&id=44ecbeac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44ecbeac"]])

export default __exports__